import script from "./AllChatList.vue?vue&type=script&setup=true&lang=js"
export * from "./AllChatList.vue?vue&type=script&setup=true&lang=js"

import "./AllChatList.vue?vue&type=style&index=0&id=1fd2babb&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fd2babb"]])

export default __exports__